import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';

import useSleepAndRestTestimonialsData from './_hooks/useSleepAndRestTestimonialsData';

const SleepAndRestTestimonials = () => {
  const sleepAndRestTestimonials = useSleepAndRestTestimonialsData();
  return (
    <div data-cy="sleep-and-rest-testimonials" className="pt-10">
      <LandingPageTestimonials
        testimonials={sleepAndRestTestimonials}
        theme="blue"
        inverted
      />
    </div>
  );
};

export default SleepAndRestTestimonials;
